module.exports = __webpack_public_path__ + "img/blend3icon1.9b041c99.png";